import toPLN from "../global/toPLN";
import useRole from "../../hooks/useRole";

export default function RaportTotal({data}) {
    const role = useRole();
    return data && (
        <div className="heading-diagrams">
            <div className="score"><p>Wolumen sprzedaży: </p><h6>{data.volume.toFixed(2)} l</h6></div>
            <div className="score"><p>Sprzedaż netto: </p><h6>{toPLN(data.netto)}</h6></div>
            {role !== 'supply' && <div className="score"><p>Sumaryczna marża: </p><h6>{toPLN(data.margin)}</h6></div>}
            <div className="score"><p>Ilość Klientów: </p><h6>{data.clients}</h6></div>
            <div className="score"><p>Średni koszyk: </p><h6>{toPLN(data.basket)}</h6></div>
        </div>
    )
}
